/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ExploreActiveItemResponse
 */
export interface ExploreActiveItemResponse {
  /**
   *
   * @type {boolean}
   * @memberof ExploreActiveItemResponse
   */
  idIsPresentInGvMenu: boolean
  /**
   *
   * @type {string}
   * @memberof ExploreActiveItemResponse
   */
  menuPathGv: string
}

/**
 * Check if a given object implements the ExploreActiveItemResponse interface.
 */
export function instanceOfExploreActiveItemResponse(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'idIsPresentInGvMenu' in value
  isInstance = isInstance && 'menuPathGv' in value

  return isInstance
}

export function ExploreActiveItemResponseFromJSON(
  json: any,
): ExploreActiveItemResponse {
  return ExploreActiveItemResponseFromJSONTyped(json, false)
}

export function ExploreActiveItemResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExploreActiveItemResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    idIsPresentInGvMenu: json['idIsPresentInGvMenu'],
    menuPathGv: json['menuPathGv'],
  }
}

export function ExploreActiveItemResponseToJSON(
  value?: ExploreActiveItemResponse | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    idIsPresentInGvMenu: value.idIsPresentInGvMenu,
    menuPathGv: value.menuPathGv,
  }
}
